<!-- manga-list.component.html -->
<div class="contenedor">
    <div class="manga-card" *ngFor="let manga of mangas">
        <img [src]="manga.imagen" [alt]="manga.titulo">
        <h3>{{ manga.titulo }}</h3>
        <p>{{ manga.autor }}</p>
    </div>
</div>
